import configsys from '../conf';

const network = {

  async post(url = '', data = {}) {
    const response = await fetch(configsys.apiUrl+url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      //mode: 'no-cors', // no-cors, *cors, same-origin
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return await response.json();
  },


}

export default network;
